<div class="container">
  <h1 class="page-title"><span class="icon"><i
        class="fas fa-plane-departure"></i></span>Booking({{this.bookingNo}}){{'ForwarderUpdate.Header' | translate }}
  </h1>
  <p-card>
    <form class="detail-form" [formGroup]="editForm">
      <div>
        <div class="forwarder-title">
          {{'ForwarderUpdate.ForwarderTitle.RecipientInfo' | translate }}
        </div>
      </div>
      <!-- 收貨人資訊 - Start -->
      <div class="mt-3">
        <div class="grid">
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.RecipientPersonName' | translate }}</b></div>
          <div class="col-3 column-value">
            <laas-text-area-set
              [row]="1"
              [maxlength]="70"
              [(ngModel)]="updateParams.recipientPersonName"
              class="p-fluid"
              formControlName="recipientPersonName">
            </laas-text-area-set>
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.RecipientCompanyName' | translate }}</b>
          </div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.recipientCompanyName}}
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.RecipientPhoneNumber' | translate }}</b></div>
          <div class="col-3 column-value">
            <laas-text-area-set
              [row]="1"
              [maxlength]="15"
              [(ngModel)]="updateParams.recipientPhoneNumber"
              class="p-fluid"
              formControlName="recipientPhoneNumber">
            </laas-text-area-set>
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.RecipientStreetLines' | translate }}</b>
          </div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.recipientStreetLines}}
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.RecipientStreetLines2' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.recipientStreetLines2}}
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.RecipientStreetLines3' | translate
              }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.recipientStreetLines3}}
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.RecipientCity' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="recipientCity" [(ngModel)]="updateParams.recipientCity" />
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.RecipientPostalCode' | translate }}</b>
          </div>
          <div class="col-3 column-value">
            <laas-text-area-set
              [row]="1"
              [maxlength]="10"
              [(ngModel)]="updateParams.recipientPostalCode"
              class="p-fluid"
              formControlName="recipientPostalCode">
            </laas-text-area-set>
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.RecipientCountryCode' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.recipientCountryCode}}
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.RecipientStateOrProvinceCode' | translate }}</b></div>
          <div class="col-3 column-value">
            <laas-text-area-set
              [row]="1"
              [maxlength]="2"
              [(ngModel)]="updateParams.recipientStateOrProvinceCode"
              class="p-fluid"
              formControlName="recipientStateOrProvinceCode">
            </laas-text-area-set>
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ShipperAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.shipperAccountId}}
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.PayType' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-dropdown formControlName="payType" [options]="payTypeOptions" [(ngModel)]="updateParams.payType" [showClear]="false"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BillingAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="billingAccountId"
              [(ngModel)]="updateParams.billingAccountId" />
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.DutyAndTaxPayerPayType' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-dropdown formControlName="dutyAndTaxPayerPayType" [options]="payTypeOptions" [(ngModel)]="updateParams.dutyAndTaxPayerPayType" [showClear]="false"
              placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
            </p-dropdown>
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.DutyAndTaxPayerAccountId' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="dutyAndTaxPayerAccountId"
              [(ngModel)]="updateParams.dutyAndTaxPayerAccountId" />
          </div>
          <div class="col-2 col-offset-1 column-label">{{'ForwarderUpdate.Form.Consignee C/O' | translate }}</div>
          <div class="col-3 column-value">
            {{this.coOrgIdDesc}}
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.Currency' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="currency" [(ngModel)]="updateParams.currency" />
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.CustomsValue' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-inputNumber formControlName="customsValue" [(ngModel)]="updateParams.customsValue" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="6"></p-inputNumber>
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.DisplayHsCodeStrs' | translate }}</b></div>
          <div class="col-3 column-value">
            <div class="grid">
              <p-chips class="col-10 p-fluid" [(ngModel)]="displayHsCodeStrs" [ngModelOptions]="{standalone: true}"
                [disabled]="true" seperator=","></p-chips>
              <button pButton pRipple type="button" class="col-2" icon="far fa-hand-pointer"
                (click)="toogleBtnClick($event)"></button>
            </div>
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.Reference' | translate }}</b></div>
          <laas-text-area-set
            [row]="1"
            [maxlength]="35"
            [(ngModel)]="updateParams.customerReference"
            class="p-fluid col-2"
            formControlName="customerReference">
          </laas-text-area-set>
          <button pButton pRipple type="button" class="col-1 p-button-secondary" icon="fas fa-delete-left"
            (click)="clearReference($event)"></button>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.TotalGrosswgt' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.totalGrosswgt}}
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.TotalCaseCnt' | translate }}</b></div>
          <div class="col-3 column-value">
            {{this.forwarderInfo?.totalCaseCnt}}
          </div>
          <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ToTypeCode' | translate }}</b></div>
          <div class="col-3 column-value">
            <p-dropdown appendTo="body" inputId="toTypeCode" placeholder="{{ 'Common.DropDown.Select' | translate}}"
              formControlName="toTypeCode" [showClear]="true" [(ngModel)]="updateParams.toTypeCode"
              [options]="typCodeOptions"></p-dropdown>
          </div>
          <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ToTypeNumber' | translate }}</b></div>
          <div class="col-3 column-value">
            <input type="text" pInputText formControlName="toTypeNumber" [(ngModel)]="updateParams.toTypeNumber" />
          </div>
        </div>
      </div>
      <!-- 收貨人資訊 - End -->
      <!-- 託運人資訊 - Start -->
      <div class="mt-5">
        <div class="forwarder-title">
          {{'ForwarderUpdate.ForwarderTitle.ShipperInfo' | translate }}
        </div>
        <div class="mt-3">
          <div class="grid">
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.shipperName' | translate }}</b></div>
            <div class="col-3 column-value">
              <laas-text-area-set
                [row]="1"
                [maxlength]="70"
                [(ngModel)]="updateParams.shipperPersonName"
                class="p-fluid"
                formControlName="shipperPersonName">
              </laas-text-area-set>
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ShipperCompanyName' | translate }}</b>
            </div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperCompanyName}}
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ShipperPhoneNumber' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperPhoneNumber}}
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ShipperEmailAddress' | translate
                }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperEmailAddress}}
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ShipperStreetLines' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperStreetLines}}
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ShipperStreetLines2' | translate
                }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperStreetLines2}}
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ShipperStreetLines3' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperStreetLines3}}
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ShipperCity' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperCity}}
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.ShipperCountryCode' | translate }}</b></div>
            <div class="col-3 column-value">
              {{this.forwarderInfo?.shipperCountryCode}}
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.FromTypeCode' | translate }}</b></div>
            <p-dropdown appendTo="body" inputId="fromTypeCode" formControlName="fromTypeCode" class="col-3 column-value"
              placeholder="{{ 'Common.DropDown.Select' | translate}}" [showClear]="true"
              [(ngModel)]="updateParams.fromTypeCode" [options]="typCodeOptions"></p-dropdown>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.fromTypeNumber' | translate }}</b></div>
            <div class="col-3 column-value">
              <input type="text" pInputText formControlName="fromTypeNumber"
                [(ngModel)]="updateParams.fromTypeNumber" />
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.PltFlag' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-checkbox [binary]="true" formControlName="pltFlag"
                label="{{'ForwarderUpdate.Form.PltFlagLabel' | translate}}" [(ngModel)]="isPaperless"></p-checkbox>
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.NoKj3Flag' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-checkbox [binary]="true" formControlName="isNoKj3"
                label="{{'ForwarderUpdate.Form.PltFlagLabel' | translate}}"
                [(ngModel)]="updateParams.isNoKj3" (ngModelChange)="onIsNoKj3Change($event)"></p-checkbox>
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.PickupType' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-dropdown appendTo="body" inputId="pickupType" formControlName="pickupType"
                placeholder="{{ 'Common.DropDown.Select' | translate}}" [showClear]="true"
                [(ngModel)]="updateParams.pickupType" [options]="pickupTypeOptions"></p-dropdown>
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.ServiceType' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-dropdown appendTo="body" inputId="serviceType" formControlName="serviceType"
                placeholder="{{ 'Common.DropDown.Select' | translate}}" [showClear]="true"
                [(ngModel)]="updateParams.serviceType" [options]="serviceTypeOptions"></p-dropdown>
            </div>
            <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.PackagingType' | translate }}</b></div>
            <div class="col-3 column-value">
              <p-dropdown appendTo="body" inputId="packagingType" formControlName="packagingType"
                placeholder="{{ 'Common.DropDown.Select' | translate}}" [showClear]="true"
                [(ngModel)]="updateParams.packagingType" [options]="packagingTypeOptions"></p-dropdown>
            </div>
            <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.InternationalBrokerServiceOption' | translate }}</b>
            </div>
            <div class="col-3 column-value">
              <p-checkbox [binary]="true" formControlName="isIbsoFlag"
                label="{{'ForwarderUpdate.Form.PltFlagLabel' | translate}}"
                [(ngModel)]="updateParams.isIbsoFlag"></p-checkbox>
            </div>
          </div>
        </div>
      </div>
      <!-- 託運人資訊 - End -->
      <!-- 指定清關代理人服務 - Start -->
      <p-accordion>
        <p-accordionTab header="{{'ForwarderUpdate.Form.InternationalBrokerServiceOption' | translate }}">
          <div>
            <div class="grid">
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerCompanyName' | translate }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="35"
                  [(ngModel)]="updateParams.brokerCompanyName"
                  class="p-fluid"
                  formControlName="brokerCompanyName">
                </laas-text-area-set>
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerContactName' | translate
                  }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="70"
                  [(ngModel)]="updateParams.brokerContactName"
                  class="p-fluid"
                  formControlName="brokerContactName">
                </laas-text-area-set>
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerCountryTerritory' | translate }}</b>
              </div>
              <div class="col-3 column-value">
                <p-dropdown
                  formControlName="brokerCountryTerritory"
                  [(ngModel)]="updateParams.brokerCountryTerritory"
                  [options]="countryOptions"
                  [showClear]="true"
                  (onChange)="changeBrokerCityOptions()"
                  [filter]="true"
                  [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerAddressLine1' | translate
                  }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="35"
                  [(ngModel)]="updateParams.brokerAddressLine1"
                  class="p-fluid"
                  formControlName="brokerAddressLine1">
                </laas-text-area-set>
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerAddressLine2' | translate }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="35"
                  [(ngModel)]="updateParams.brokerAddressLine2"
                  class="p-fluid"
                  formControlName="brokerAddressLine2">
                </laas-text-area-set>
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerCity' | translate }}</b></div>
              <div class="col-3 column-value">
                <p-dropdown
                  formControlName="brokerCity"
                  [(ngModel)]="updateParams.brokerCity"
                  [options]="cityOptions"
                  [showClear]="true"
                  [filter]="true"
                  [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  styleClass="p-text-left"
                >
                </p-dropdown>
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerPostalCode' | translate }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="10"
                  [(ngModel)]="updateParams.brokerPostalCode"
                  class="p-fluid"
                  formControlName="brokerPostalCode">
                </laas-text-area-set>
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerStateOrProvinceCode' | translate }}</b></div>
              <div class="col-3 column-value">
                <input type="text" pInputText formControlName="brokerStateOrProvinceCode"
                  [(ngModel)]="updateParams.brokerStateOrProvinceCode" [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null" />
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerFirstPhone' | translate }}</b>
              </div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="15"
                  [(ngModel)]="updateParams.brokerFirstPhone"
                  class="p-fluid"
                  formControlName="brokerFirstPhone">
                </laas-text-area-set>
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerSecondPhone' | translate }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="15"
                  [(ngModel)]="updateParams.brokerSecondPhone"
                  class="p-fluid"
                  formControlName="brokerSecondPhone">
                </laas-text-area-set>
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerFax' | translate }}</b></div>
              <div class="col-3 column-value">
                <input type="text" pInputText formControlName="brokerFax" [(ngModel)]="updateParams.brokerFax"
                  [readonly]="!updateParams.isIbsoFlag" [attr.disabled]="!updateParams.isIbsoFlag ? '' : null" />
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerExpressAccount' | translate
                  }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="9"
                  [(ngModel)]="updateParams.brokerExpressAccount"
                  class="p-fluid"
                  formControlName="brokerExpressAccount">
                </laas-text-area-set>
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerBankAccount' | translate }}</b></div>
              <div class="col-3 column-value">
                <input type="text" pInputText formControlName="brokerBankAccount"
                  [(ngModel)]="updateParams.brokerBankAccount" [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null" />
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerTradeNumber' | translate
                  }}</b></div>
              <div class="col-3 column-value">
                <input type="text" pInputText formControlName="brokerTradeNumber"
                  [(ngModel)]="updateParams.brokerTradeNumber" [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null" />
              </div>
              <div class="col-2 column-label"><b>{{'ForwarderUpdate.Form.BrokerVatCustomsEin' | translate }}</b></div>
              <div class="col-3 column-value">
                <input type="text" pInputText formControlName="brokerVatCustomsEin"
                  [(ngModel)]="updateParams.brokerVatCustomsEin" [readonly]="!updateParams.isIbsoFlag"
                  [attr.disabled]="!updateParams.isIbsoFlag ? '' : null" />
              </div>
              <div class="col-2 col-offset-1 column-label"><b>{{'ForwarderUpdate.Form.BrokerEmail' | translate }}</b></div>
              <div class="col-3 column-value">
                <laas-text-area-set
                  [row]="1"
                  [maxlength]="80"
                  [(ngModel)]="updateParams.brokerEmail"
                  class="p-fluid"
                  formControlName="brokerEmail">
                </laas-text-area-set>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
      <!-- 指定清關代理人服務 - End -->

      <div class="grid mt-2">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="saveBtn($event)"
            class="mr-2"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeWindow($event)"
            class="p-button-secondary"></button>
        </div>
      </div>
      <p-dialog header="{{'ForwarderUpdate.Dialog' | translate }}" appendTo="body"
        [(visible)]="isShowHsCodeModificationModal" [modal]="true" [draggable]="false" [resizable]="false"
        [dismissableMask]="true" [style]="{ width: '60%' }">
        <div>
          <div class="field grid">
            <div class="col-6 column-label text-center"><strong>Sku Description(Original)</strong></div>
            <div class="col-6 column-label text-center"><strong>Sku Description</strong></div>
          </div>
        </div>
        <div formArrayName="forwarderInvoices" class="mt-3">
          <div *ngFor="let option of distinctSkuDescriptions || []; index as i" class="field grid"
            [formGroupName]="i">
            <div class="col-6 column-label text-center">
              <label>{{option.originalSkuDescription}}</label>
            </div>
            <div class="col-6 column-value text-center">
              <laas-text-area-set
                *ngIf="isShowHsCodeModificationModal"
                [row]="1"
                [maxlength]="60"
                class="p-fluid"
                formControlName="skuDescription">
              </laas-text-area-set>
            </div>
          </div>
        </div>
        <div class="grid mt-2">
          <div class="col text-center">
            <button pRipple pButton label="{{ 'Common.Button.Confirm' | translate }}"
              (click)="confirmBtnClick($event)"></button>
            <button pRipple pButton label="{{ 'Common.Button.Clean' | translate }}"
              (click)="cleanAllDescription($event)" class="p-button-secondary"></button>
          </div>
        </div>
      </p-dialog>
    </form>
  </p-card>
</div>